__turbopack_context__.v({
  "root": "SleepContributorModal-module__lTRBBW__root",
});
